import gql from 'graphql-tag';

export const SaveAssociateNotificationWithContact = gql`
mutation SaveAssociateNotificationWithContact($contactId: String,$notificationId: String) {
  saveAssociateNotificationWithContact(contactId: $contactId,notificationId:$notificationId){
    id
    content
    closeNotification
    checkTagsAND
    checkTagsOR
    dashboardTypes
    showDashboardTypes_Formatted
    tags_Formatted
    __typename
  }
}
`;

